<template>
  <div>
    <b-row align-h="between" style="margin-left: 0; margin-right: 0;">
      <h3>Alle Termine:</h3>
      <div>
        <b-button variant="outline-primary" to="Termine/Neu">Erstellen</b-button>
      </div>
    </b-row>
    <div class="overflow-auto">
      <b-pagination-nav
          :link-gen="linkGen"
          :number-of-pages="pages"
          align="fill"
          use-router
      />
    </div>
    <b-table :items="events" :fields="fields" :busy="!events" @row-clicked="openEventEdit" :hover="true">
      <template #cell(start)="data">
        {{ formatDate(data.item.start, data.item.start_time) }}
      </template>

      <template #cell(end)="data">
        {{ formatDate(data.item.end, data.item.end_time) }}
      </template>
    </b-table>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import router from '@/router'

export default {
  name: 'EventList',
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: '#'
        },
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'start',
          label: 'Start'
        },
        {
          key: 'end',
          label: 'Ende'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getStoredEventsByPage',
      'getEventPages'
    ]),
    events() {
      const unsortedEvents = this.getStoredEventsByPage(parseInt(this.$route.query.page))
      return unsortedEvents.sort((event1, event2) => {
        return event1.start < event2.start
      })
    },
    pages() {
      return this.getEventPages
    },
  },
  mounted() {
    this.getEvents(this.$route.query.page)
  },
  watch: {
    '$route.query.page'() {
      this.getEvents(this.$route.query.page)
    }
  },
  methods: {
    ...mapActions([
      'getEvents',
    ]),
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },
    openEventEdit(item) {
      router.push('Termine/' + item.id)
    },
    formatDate (oldDate, time = '00:00:00') {
      const date = new Date(oldDate)
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1

      return day + '.' + month + '.' + date.getFullYear() + ' ' + time.slice(0, -3)
    }
  }
}
</script>

<style scoped>

</style>
